module.exports = __webpack_public_path__ + "media/img/kbv-logo-7cea91f2397ed5d016c4ba64dfbf6b94.png";